import { useTranslation } from 'react-i18next';
import { useLanguage } from '@/contexts/LanguageContext';
import SEOHead from '@/components/common/SEOHead';
import WCSubmenu from '@/components/worldcup/WCSubmenu';
import { Ticket, Lock } from 'lucide-react';

const HERO_BG = 'https://static.prod-images.emergentagent.com/jobs/2b79e76a-42eb-4df3-ab27-72c6bfd04714/images/99c60ac7eb24aeb265f23319b759224ca0d51ca1663ab79e96d716e8c59c1e36.png';

export default function WorldCupTickets() {
  const { t } = useTranslation();
  const { currentLang } = useLanguage();

  return (
    <div data-testid="wc-tickets-page">
      <WCSubmenu />
      <SEOHead title={t('wc.tickets') + ' - ' + t('wc.breadcrumb') + ' | ODDSIS'} />

      <div className="relative overflow-hidden min-h-[60vh] flex items-center justify-center">
        <img src={HERO_BG} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/80 to-slate-950/40" />

        <div className="relative z-10 text-center px-4 max-w-xl">
          <div className="w-20 h-20 mx-auto mb-6 rounded-2xl bg-amber-500/10 border border-amber-500/20 flex items-center justify-center shadow-[0_0_30px_rgba(245,158,11,0.2)]">
            <Ticket className="w-10 h-10 text-amber-400" />
          </div>
          <h1 className="text-3xl md:text-5xl font-black text-white mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
            {t('wc.ticketTitle')}
          </h1>
          <p className="text-lg text-slate-300 mb-6" style={{ fontFamily: 'Manrope, sans-serif' }}>
            {t('wc.ticketDesc')}
          </p>
          <div className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-amber-500/10 border border-amber-500/30 text-amber-400 font-semibold text-sm">
            <Lock className="w-4 h-4" />
            {t('wc.comingSoon')}
          </div>
          <p className="text-xs text-slate-500 mt-8">
            {t('wc.ticketApiWait')}
          </p>
        </div>
      </div>
    </div>
  );
}
